// extracted by mini-css-extract-plugin
export default {"sign-in-box":"ToSignUpView_sign-in-box__SoPF0"};